import { yup } from '@/libs/yup';
import { schema as permissionSchema } from '../edit/parts/PermissionForm/schema';

export const schema = yup
  .object({
    email: yup.string().required().email().label('メールアドレス'),
    name: yup.string().max(20).label('氏名')
  })
  .concat(permissionSchema);

export type Schema = yup.InferType<typeof schema>;
